export type Transformation =
  | 'cover' // Preserving aspect ratio, ensure the image covers both provided dimensions by cropping/clipping to fit. (default)
  | 'contain' // Preserving aspect ratio, contain within both provided dimensions using "letterboxing" where necessary.
  | 'fill' // Ignore the aspect ratio of the input and stretch to both provided dimensions.
  | 'inside' // Preserving aspect ratio, resize the image to be as large as possible while ensuring its dimensions are less than or equal to both those specified.
  | 'outside'; // Preserving aspect ratio, resize the image to be as small as possible while ensuring its dimensions are greater than or equal to both those specified.

const RESIZED_IMAGE_BASE_URL =
  process.env.NEXT_PUBLIC_IMAGE_BASE_URL || process.env.IMAGE_BASE_URL || '';

export type GetResizedImageUrlFunction = (
  filename: string,
  width: number,
  height?: number,
  transformation?: Transformation,
  backgroundColor?: string
) => string;

/**
 * This helper function generates URLs to the AA image resize service.
 *
 * @param filename must be a relative path to a file in the S3 bucket of the service; external paths are currently not supported.
 * @param background a six-digit, lowercase hex color with optional leading hash; example: `#fafafa`
 */
export const getResizedImageUrl: GetResizedImageUrlFunction = (
  filename: string,
  width: number,
  height?: number,
  transformation?: Transformation,
  backgroundColor?: string
) => {
  let url = `${RESIZED_IMAGE_BASE_URL}/${Math.round(width)}`;

  if (typeof height === 'number') {
    url += 'x' + Math.round(height);
  }

  if (transformation) {
    url += '_' + transformation;

    if (backgroundColor) {
      url += '_' + backgroundColor.replace(/^#/, '');
    }
  }

  url += '/' + filename;

  return url;
};
